// SHARE — 공유 URL·설명 조립(순수 함수, RULES#143). ShareDock 이 쓴다.
//
// 복사 = 순수 URL(UTM 없음 · Q-S1). 카카오/네이티브 = UTM. 착지 canonical 은 원본 그대로(UTM 은 쿼리일 뿐 — 기존 canonical 체계 불변).
// 설명 120자 절단은 text-safe 경유(서로게이트 반토막 전례).

import { safeSlice } from '@/lib/text-safe';

export type ShareSurface = 'apt' | 'blog' | 'board' | 'stock' | 'daily';

const DEFAULT_DESC = '카더라에서 확인하세요';

/** 원본 URL 에서 쿼리·해시를 떼어 «깨끗한 주소» 로. 못 읽으면 입력 그대로. */
export function cleanUrl(url: string): string {
  try {
    const u = new URL(url);
    u.search = ''; u.hash = '';
    return u.toString();
  } catch { return url; }
}

export function buildShareUrls(url: string, surface: ShareSurface): { copy: string; kakao: string; native: string } {
  const base = cleanUrl(url);
  const q = (medium: string) => `${base}?utm_source=share&utm_medium=${medium}&utm_campaign=${surface}`;
  return { copy: base, kakao: q('kakao'), native: q('native') };
}

export function shareDescription(d: string | null | undefined): string {
  const t = (d ?? '').replace(/\s+/g, ' ').trim();
  return t ? safeSlice(t, 120) : DEFAULT_DESC;
}

/** Q4 공유 FAB — 추적 파라미터(utm_* · n_*)와 해시만 떼어 낸 주소. 다른 쿼리는 둔다. 못 읽으면 입력 그대로. */
export function stripTracking(url: string): string {
  try {
    const u = new URL(url);
    for (const k of Array.from(u.searchParams.keys())) {
      if (/^(utm_|n_)/i.test(k)) u.searchParams.delete(k);
    }
    u.hash = '';
    return u.toString();
  } catch { return url; }
}

/** Q4 공유 FAB — 공유 주소 = 페이지 canonical(있으면) · 없으면 현재 주소. 어느 쪽이든 추적 파라미터 제거. 상대 canonical 은 현재 주소 기준으로 푼다. */
export function pickShareUrl(canonical: string | null | undefined, current: string): string {
  const c = (canonical ?? '').trim();
  if (c) {
    try { return stripTracking(new URL(c, current).toString()); } catch { /* 현재 주소로 */ }
  }
  return stripTracking(current);
}

/** Q4 공유 FAB — 네이버 밴드 공유 주소(band.us 공유 플러그인 경로). route = 출처 도메인. */
export function bandShareUrl(url: string, title: string): string {
  let route = 'kadeora.app';
  try { route = new URL(url).host || route; } catch { /* 기본값 */ }
  const body = [title.trim(), url].filter(Boolean).join('\n');
  return `https://band.us/plugin/share?body=${encodeURIComponent(body)}&route=${encodeURIComponent(route)}`;
}
